import { createSelector } from '@reduxjs/toolkit';
import { selectCeilingHeightValue } from './selectCeilingHeightValue';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'От 2,5 м', value: 2.5 },
  { label: 'От 2,7 м', value: 2.7 },
  { label: 'От 3 м', value: 3 },
  { label: 'От 3,5 м', value: 3.5 },
  { label: 'От 4 м', value: 4 },
];

export const selectCeilingHeightFilter = createSelector(selectCeilingHeightValue, value => ({
  label: 'Высота потолков',
  value: [value],
  options: OPTIONS,
}));
